<template>
    <div>
        <p style="text-align: left">
            <b
                v-if="courseFilter != 'Hors course' && participants.list_parcours && participants.list_parcours[courseFilter] && participants.list_parcours[courseFilter].metadata.heure_depart != 'prévu à '">Départ
                {{ participants.list_parcours[courseFilter].metadata.heure_depart }}
                | </b><b>{{ translated_stats }}</b>
        </p>
    </div>
</template>

<script>
export default {
    computed: {
        courseFilter() {
            return this.$store.getters["listCoureurs/courseFilter"];
        },
        participants() {
            return this.$store.getters["listCoureurs/participants"];
        },
        translated_stats() {
            return this.$store.getters["listCoureurs/translated_stats"];
        }
    },
}

</script>

<style lang="scss" scoped></style>